import type { BaseQLMiddleware } from '@adornis/baseql/metadata/types.js';
import { context } from '@adornis/baseql/server/context.js';
import { ExpectedError } from '@adornis/validation/errors/ExpectedError.js';

// TODO this should be engine when baseql is refactored and has good disconnect handlers

const throttleMap = new Map<string, number>();

function buildRequestID(sessionID: string, operationName: string) {
  return sessionID + '-' + operationName;
}

export const throttleMiddleware =
  (ms: number): BaseQLMiddleware =>
  async options => {
    // server should not be throttled
    if (context.serverContext) return options.next();

    const requestID = buildRequestID(options.context.sessionID, options.field.name);
    if (throttleMap.has(requestID)) {
      throw new ExpectedError('Sie können diese Funktion nicht so schnell hintereinander ausführen.');
    }
    throttleMap.set(requestID, Date.now());
    setTimeout(() => {
      throttleMap.delete(requestID);
    }, ms);
    return options.next();
  };
